import {
  IQuotePaymentTermCode,
  IQuotePaymentTermCodeData
} from '../quote-payment-term-code';
import {
  IServiceComputationFieldError,
  IServiceComputationFieldErrorData,
  IServicePriceComputation,
  IServicePriceComputationData
} from '../quoteservicecomputation';

export enum QuoteTemplateTranslationLanguage {
  en = 'en-US',
  es = 'es-ES',
  ru = 'ru-RU'
}

export interface IQuoteTemplateData {
  id?: number;
  title: string;
  description: string;
  order?: number;
  language?: QuoteTemplateTranslationLanguage;
  note?: string;
}

export type IQuoteServiceTemplateData = IQuoteTemplateData & {
  price_computations: IServicePriceComputationData[];
  days_computations: IServicePriceComputationData[];
};

export type IQuoteFreightTemplateData = IQuoteTemplateData;

export interface IQuotePaymentTermTemplateData extends IQuoteTemplateData {
  is_archived?: boolean;
  code?: IQuotePaymentTermCodeData | number | null;
}

export interface IQuoteTermTemplateData extends IQuoteTemplateData {
  organization: number;
}

export interface IQuoteTemplate extends IQuoteTemplateData {
  validate(): boolean;
}

export interface IQuoteServiceTemplate extends IQuoteTemplate {
  price_computations: IServicePriceComputation[];
  days_computations: IServicePriceComputation[];

  validate(): boolean;
}

export interface IQuoteFreightTemplate extends IQuoteTemplate {
  validate(): boolean;
}

export interface IQuotePaymentTermTemplate
  extends IQuotePaymentTermTemplateData {
  code: IQuotePaymentTermCode | number | null;

  validate(): boolean;
}

export interface IQuoteTermTemplate extends IQuoteTermTemplateData {
  validate(): boolean;
}

// Field Errors
export interface IQuoteTemplateFieldErrorData {
  title?: string[];
  description?: string[];
  note?: string[];
}
export interface IQuoteTermTemplateFieldErrorData
  extends IQuoteTemplateFieldErrorData {
  organization?: string[];
}
export interface IQuoteServiceTemplateFieldErrorData {
  title?: string[];
  description?: string[];
  note?: string[];
  price_computations?: IServiceComputationFieldErrorData[];
  days_computations?: IServiceComputationFieldErrorData[];
}

export interface IQuotePaymentTermTemplateFieldErrorData
  extends IQuoteTemplateFieldErrorData {
  is_archived?: string[];
  code?: string[];
}

export interface IQuoteTemplateFieldError extends IQuoteTemplateFieldErrorData {
  clearErrors(): void;
}
export interface IQuoteTermTemplateFieldError
  extends IQuoteTermTemplateFieldErrorData {
  clearErrors(): void;
}

export interface IQuotePaymentTermTemplateFieldError
  extends IQuotePaymentTermTemplateFieldErrorData {
  clearErrors(): void;
}

export interface IQuoteServiceTemplateFieldError
  extends IQuoteServiceTemplateFieldErrorData {
  price_computations?: IServiceComputationFieldError[];

  clearErrors(): void;
}
